export default __webpack_public_path__ + "static/media/cg_logo_small.bc4dbd12.png";